import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

import { Tooltip } from '../tooltip';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import styles from './styles';

const useStyles = makeStyles(styles);
export function CriteriaBox(props) {
  const classes = useStyles(props);
  const {
    className,
    title,
    children,
    actions,
    hideActionsUntilHover = true,
    hasTooltip = true,
    hasCancelIcon = true,
    onCancel,
    TooltipContent,
  } = props;

  return (
    <div data-testid='criteria-box' className={clsx(classes.root, className)}>
      <div className={clsx(classes.title, 'Criteria-Box-Title')}>{title}</div>
      <div className={clsx(classes.body, 'Criteria-Box-Body')}>{children}</div>
      <div
        className={clsx(
          classes.actions,
          { [classes.hideActionsUntilHover]: hideActionsUntilHover },
          'Criteria-Box-Actions',
        )}
      >
        {actions}
        {hasTooltip && Boolean(TooltipContent) && (
          <Tooltip
            data-testid='tooltip-icon'
            className={clsx(classes.icon, 'Tooltip-Icon')}
            TitleContent={TooltipContent}
          />
        )}
        {hasCancelIcon && Boolean(onCancel) && (
          <CancelOutlinedIcon
            data-testid='cancel-icon'
            onClick={onCancel}
            className={clsx(classes.icon, 'Cancel-Icon')}
          />
        )}
      </div>
    </div>
  );
}

CriteriaBox.defaultProps = {
  hideActionsUntilHover: true,
  hasTooltip: true,
  hasCancelIcon: true,
};

CriteriaBox.propTypes = {
  /** Classes to override */
  classes: PropTypes.object,
  className: PropTypes.string,
  /** Title of the criteria box - left aligned */
  title: PropTypes.node,
  /** Content in the center of the criteria box */
  children: PropTypes.node,
  /** Actions on the right side of the criteria box */
  actions: PropTypes.node,
  /** Boolean to show/hide actions until hovering */
  hideActionsUntilHover: PropTypes.bool,
  /** Boolean to add tooltip by default */
  hasTooltip: PropTypes.bool,
  /** Boolean to add cancel icon by default */
  hasCancelIcon: PropTypes.bool,
  /** Function called on clicking cancel button */
  onCancel: PropTypes.func,
  /** Content displayed on hover over tooltip (if it exists) */
  TooltipContent: PropTypes.node,
};

export default CriteriaBox;
